let app = null
let auth = null

// Check if we're in a test environment
const isTestEnvironment = process.env.NODE_ENV === 'test' || process.env.VITEST === 'true'

if (typeof window !== 'undefined' && !isTestEnvironment) {
  const { initializeApp } = require('firebase/app')
  const { getAuth } = require('firebase/auth')

  const firebaseConfig = {
    apiKey: process.env.GATSBY_FIREBASE_API_KEY,
    authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
    storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.GATSBY_FIREBASE_APP_ID
  }

  app = initializeApp(firebaseConfig)
  auth = getAuth(app)
}

export { auth }
export default app